import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Play } from 'lucide-react';
import { useSiteData } from '../contexts/SiteDataContext';

const VideosSection = () => {
  const { videos: videosData } = useSiteData();
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section id="videos" ref={ref} className="py-24 bg-gradient-to-br from-blue-900 via-blue-950 to-blue-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-orange-400 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-400 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>
            वीडियो गैलरी
          </h2>
          <p 
            className="text-xl text-orange-400 font-semibold"
            style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
          >
            साक्षात्कार • विमोचन • प्रचार
          </p>
          <p className="text-gray-300 mt-4" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>साक्षात्कार, पुस्तक विमोचन और प्रचार वीडियो देखें</p>
        </motion.div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {videosData.map((video, index) => (
            <motion.div
              key={video.id}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
              className="group relative"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-white/20">
                {/* Video Thumbnail */}
                <div className="relative aspect-video overflow-hidden">
                  <iframe
                    src={video.embedUrl}
                    title={video.title}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>

                {/* Video Title */}
                <div className="p-6">
                  <h3 className="text-white font-bold text-lg mb-2">{video.title}</h3>
                  <div className="flex items-center gap-2 text-orange-400">
                    <Play className="h-4 w-4" />
                    <span className="text-sm" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>अभी देखें</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideosSection;